import React from 'react';
import TextAbout from './TextAbout';





function About() {
    return (
        <div id="about">
                <TextAbout/>
        </div>


    );
}

export default About;